import React from 'react';
import SubjectIcon from '@mui/icons-material/Subject';
import ShortTextIcon from '@mui/icons-material/ShortText';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import BusinessIcon from '@mui/icons-material/Business';
import PublishIcon from '@mui/icons-material/Publish';
import { MenuItem } from '@material-ui/core';

import FormSelect from 'retired/FormSelect';

const QuestionType = (props) => (
  <FormSelect {...props}>
    <MenuItem value="TextInput">
      <ShortTextIcon style={{ marginRight: 5 }} />
      Short answer
    </MenuItem>
    <MenuItem value="TextArea">
      <SubjectIcon style={{ marginRight: 5 }} />
      Long answer
    </MenuItem>
    <MenuItem value="Checkbox">
      <CheckBoxIcon style={{ marginRight: 5 }} />
      Checkbox
    </MenuItem>
    <MenuItem value="MultipleChoice">
      <RadioButtonCheckedIcon style={{ marginRight: 5 }} />
      Multiple Choice
    </MenuItem>
    <MenuItem value="SelectOneDropdown">
      <ArrowDropDownCircleIcon style={{ marginRight: 5 }} />
      Select one dropdown
    </MenuItem>
    <MenuItem value="NPSScale">
      <LinearScaleIcon style={{ marginRight: 5 }} />
      NPS Scale
    </MenuItem>
    <MenuItem value="LikertScale">
      <LinearScaleIcon style={{ marginRight: 5 }} />
      Likert Scale
    </MenuItem>
    <MenuItem value="NonprofitSelector">
      <BusinessIcon style={{ marginRight: 5 }} />
      Nonprofit Selector
    </MenuItem>
    <MenuItem value="FileUpload">
      <PublishIcon style={{ marginRight: 5 }} />
      File Upload
    </MenuItem>
  </FormSelect>
);
export default QuestionType;
